/* unplugin-vue-components disabled */import script from "./list-old.vue?vue&type=script&setup=true&lang=js"
export * from "./list-old.vue?vue&type=script&setup=true&lang=js"

import "./list-old.vue?vue&type=style&index=0&id=6e6ab6e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e6ab6e6"]])

export default __exports__